import React, { useState } from "react";
import LoggingReactTable from "Components/LoggingReactTable";
import "react-datepicker/dist/react-datepicker.css";
import "tippy.js/dist/tippy.css";
import { MdErrorOutline } from "react-icons/md";
import { FaRegCheckCircle } from "react-icons/fa";
import { useLogs } from "Api/Admin/Logging";

const List = (props) => {
	const [pageSizeCount, setPageSizeCount] = useState(20);
	const [pageNumber, setPageNumber] = useState(1);
	const [searchValue, setSearchValue] = useState("");

	const {
		data: response,
		isLoading,
	} = useLogs(
		pageSizeCount,
		pageNumber,
		searchValue
	);

	const data = response?.list || [];
	const totalPageCount = response?.pageCount || 0;

	const paginate = (val) => {
		setPageNumber(val);
	};

	const handleInputChange = (val) => {
		setPageNumber(1);
		setSearchValue(val);
	};

	const filterList = (val) => {
		handleInputChange(val);
	};

	const indexPageSize = (val) => {
		setPageSizeCount(val);
	};

	const loggingTablePageSize = (val) => {
		setPageNumber(1);
		indexPageSize(val);
	};

	const columns = [
		{
			header: "Datum-tijd",
			accessorKey: "timestamp",
		},
		{
			header: "Gebruikersnaam",
			accessorKey: "username",
		},
		{
			header: "Naam",
			accessorKey: "fullname",
		},
		{
			header: "Rol",
			accessorKey: "role",
		},
		{
			header: "Type",
			accessorKey: "type",
		},
		{
			header: "Resultaat",
			accessorKey: "status",
			cell: ({ cell }) => <>{cell.getValue() === 'error' ? <MdErrorOutline color="red" /> : <FaRegCheckCircle color="green" />} </>,
		},
		{
			header: "Omschrijving",
			accessorKey: "message",
		},
		{
			header: "Ip-addres",
			accessorKey: "ipAddress",
		},
		{
			header: "Browser",
			accessorKey: "browser",
		},
	];

	return (
		<>
			<LoggingReactTable
				data={data}
				columns={columns}
				setPageNumber={setPageNumber}
				pageNumber={pageNumber}
				totalPageCount={totalPageCount}
				paginate={paginate}
				filterList={filterList}
				loggingTablePageSize={loggingTablePageSize}
				pageSizeCount={pageSizeCount}
				showLoader={isLoading}
				tableClassName="mb-0 table table-borderless table-sm table-hover table-heading-style"
			/>
		</>
	);
};

export default List;
